import { apiUrl } from "../config";
import { differenceInDays, parseISO } from 'date-fns';

// данные для динамичности
export const intervalUpdatingData = 7000 // Интервал в мс для обновления данных

export const boolElemByRole = (roles = ['hadmin']) => { 
    const userRole = localStorage.getItem('asd'); // Получаем роль из localStorage

    // Проверяем, содержится ли роль пользователя в массиве `roles`
    return roles.includes(String(userRole));
};

export const showStatusBooking = (status) => {
    switch (status) {
        case 0:
            return "Оплачено" 
        case 1:
            return "Не оплачено"
        case 2:
            return "Ожидается"
        case 3:
            return "Отменено"
        default:
            break
    }
}
export const showPaymentStatusBooking = (status) => {
    switch (status) {
        case 1:
            return "Бронь" 
        case 2:
            return "Номер"
        case 3:
            return "Бронь и номер"
        case 4:
            return "Без оплаты"
        default:
            break
    }
}
export const showStatusReception = (status) => {
    switch (status) {
        case 0:
            return "Нет на ресепшн" 
        case 1:
            return "Есть на ресепшн"
        default:
            break
    }
}

export const showTypeBooking = (type) => {
    switch (type) {
        case 0:
            return "Онлайн"
        case 1:
            return "Бланк"
        case 2:
            return "Чеком"
        case 3:
            return "Заметка"
        case 4:
            return "Перечисление"
        case 5:
            return "Терминал"
        default:
            break
    }
}


export const set_status = async (bookginId, method, type = false, numberBlankCheck = false) => {
    let isConfirmed = ''
    if (method === 'cancelBookFull' || method === 'cancelBookRefund' || method === 'cancelBookNoRefund' || method === 'cancelReceptionProgram') {
        isConfirmed = window.confirm('Подтвердить отмену брони?');
    } else if (method === 'acceptReception' || method === 'acceptReceptionProgram') {
        isConfirmed = window.confirm('Подтвердить бронь?');
    } else if (method === 'acceptPayment') {
        isConfirmed = window.confirm('Подтвердить то, что бронь оплачена?');
    } else if (method === 'returnBook') {
        isConfirmed = window.confirm('Подтвердить возвращение брони?');
    } else if (method === 'cancelReceptionFullProgram') {
        isConfirmed = window.confirm('Если удалили запись из программы то жмите ОК!');
    } else if (method === 'confirmActive') {
        isConfirmed = window.confirm('Переместить бронь в активные?');
    } else if (method === 'confirmActiveAbort') {
        isConfirmed = window.confirm('Переместить бронь в неактивные?');
    }
    if (type === false) { type = 'no' }
    const token = localStorage.getItem('accessToken');
    if (isConfirmed) {
      try {
          const response = await fetch(`${apiUrl}/api/sys/set-statusbook?booking_id=${bookginId}&type=${type}&nbc=${numberBlankCheck}&method=${method}`, {
              method: 'GET',
              headers: {
                  'Content-Type': 'application/json',
                  "Authorization": `Bearer ${token}`
              },
          });
          const data = await response.json();
            return data.request
      } catch (error) {
          console.error("Ошибка:", error);
      }
    }
  }


export function formatDateTime(dateString) {
    const date = new Date(dateString);

    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Месяцы от 0 до 11
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
export function formatDateTimeToTM(dateString = null, time = true, utc=null) {
    const date = dateString
        ? new Date(dateString)
        : new Date();

    // переводим в UTC+5
    let tmDate
    if (utc) {
        tmDate = new Date(date.getTime() + (utc * 60 * 60 * 1000));
    } else {
        tmDate = new Date(date.getTime());
    }

    const year = tmDate.getUTCFullYear();
    const month = String(tmDate.getUTCMonth() + 1).padStart(2, '0');
    const day = String(tmDate.getUTCDate()).padStart(2, '0');

    if (!time) {
        return `${day}.${month}.${year}`;
    }

    const hours = String(tmDate.getUTCHours()).padStart(2, '0');
    const minutes = String(tmDate.getUTCMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

// Получение количества дней
export function getNumberOfDays(checkIn, checkOut){
    const checkInDate = parseISO(checkIn);
    const checkOutDate = parseISO(checkOut);
    return differenceInDays(checkOutDate, checkInDate);
}
